module.exports = __webpack_public_path__ + "static/rabbit3-09c8b25fcdcd4d09c299aaa22a82061b.webp";